<template>
    <img v-if="avatarImage" :src="avatarImage" :class="classesImg" />
    <span v-else :class="classesText">
        {{ avatarText }}
    </span>
</template>

<script>
import { randAvatarColor } from 'utils/avatar';

export default {
    props: {
        firstname: {
            type: String,
            require: true,
            default: '',
        },
        lastname: {
            type: String,
            require: true,
            default: '',
        },
        avatarImage: {
            type: String,
            require: false,
            default: null,
        },
        size: {
            type: String,
            default: 'small',
            validator: (value) =>
                ['extra-small', 'small', 'medium', 'large', 'extra-large'].includes(value),
        },
    },
    computed: {
        classesImg() {
            return ['avatar', 'avatar-randomized__img', this.currentAvatarSize];
        },
        classesText() {
            return ['avatar', this.randAvatarColor, this.currentAvatarSize];
        },
        randAvatarColor: function () {
            return randAvatarColor(this.firstname, this.lastname);
        },
        currentAvatarSize: function () {
            return this.avatarSizeClass(this.size);
        },
        avatarText: function () {
            if (this.size === 'extra-small') return this.lastname[0];
            return this.firstname[0] + this.lastname[0];
        },
    },
    methods: {
        avatarSizeClass(size) {
            return {
                'extra-small': 'avatar-small',
                small: '',
                medium: 'avatar-big',
                large: 'avatar-xbig',
                'extra-large': 'avatar-xxbig',
            }[size];
        },
    },
};
</script>

<style lang="scss" scoped>
.avatar-randomized {
    &__img {
        padding: 0;
    }
}
</style>
